import { exchangeCodeForToken } from './codeExchange';
import { STEP_UP_OAUTH_CONFIG } from './constants';
import { runStepUpAuthorization } from './stepUpAuthorization';
import { StepUpPopup } from './StepUpPopup';
import type { StepUpOAuthConfig, StepUpTokenProvider } from './types';

// The default step-up token provider: run the OAuth `web_message` + PKCE flow — the
// shared AUTHORIZE PHASE (open the popup blank in-gesture → PKCE → navigate to
// /authorize → await the code), then exchange the code (+ verifier) for the token.
//
// `clientId` is required (no shared default — each consumer registers its own OAuth
// client); `authorizeUrl` / `tokenUrl` / `scope` default to the Identity endpoints
// and `redirectUri` derives from `window.location.origin` when unset (see constants).
// An unconfigured flow rejects loudly with StepUpFailedError.
export const createStepUpOAuthTokenProvider = (
  config: Partial<StepUpOAuthConfig> = {},
): StepUpTokenProvider => {
  const merged: StepUpOAuthConfig = {
    authorizeUrl: config.authorizeUrl ?? STEP_UP_OAUTH_CONFIG.AUTHORIZE_URL,
    tokenUrl: config.tokenUrl ?? STEP_UP_OAUTH_CONFIG.TOKEN_URL,
    redirectUri: config.redirectUri ?? STEP_UP_OAUTH_CONFIG.REDIRECT_URI,
    clientId: config.clientId ?? STEP_UP_OAUTH_CONFIG.CLIENT_ID,
    scope: config.scope ?? STEP_UP_OAUTH_CONFIG.SCOPE,
  };

  return async (details) => {
    const popup = new StepUpPopup({
      authorizeUrl: merged.authorizeUrl,
      redirectUri: merged.redirectUri,
      clientId: merged.clientId,
      scope: merged.scope,
    });
    const { code, codeVerifier } = await runStepUpAuthorization(details, {
      popup,
    });
    return exchangeCodeForToken(code, codeVerifier, {
      tokenUrl: merged.tokenUrl,
      redirectUri: merged.redirectUri,
      clientId: merged.clientId,
    });
  };
};
